import React from "react";
import { Link } from "react-router-dom";
import "./HeroSection.css";

const HeroSection = ({ services }) => {
  return (
    <section className="hero-section">
      <div className="hero-content d-flex flex-column justify-content-center align-items-start pt-5">
        <h1 className="hero-title">
          <span className="highlight">MAKING CONNECTIONS</span><br />
          <span className="text-accent">DELIVERING RESULTS</span>
        </h1>
        <p className="hero-subtitle">Lead in the Digital Age !</p>
      </div>

      {/* Service Buttons Section */}
      <div className="hero-buttons d-flex flex-column align-items-center mt-4">
        <div className="row w-100 justify-content-center">
          {services.map((svc) => (
            <div className="col-4 mb-3" key={svc._id}>
              <Link
                 to={`/services/${svc._id}`}
                className="no-underline"
              >
                <button className="service-btn w-100">{svc.servicename}</button>
              </Link>
            </div>
          ))}
        </div>

        {/* Call Now Button */}
        <div className="d-flex justify-content-center mt-4">
        <a href="tel: +251902340084">
  <button className="simple-btn">Call Now</button>
</a>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
